import { render, staticRenderFns } from "./ErpConnectList.vue?vue&type=template&id=1c87677c&scoped=true"
import script from "./ErpConnectList.vue?vue&type=script&lang=js"
export * from "./ErpConnectList.vue?vue&type=script&lang=js"
import style0 from "./ErpConnectList.vue?vue&type=style&index=0&id=1c87677c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c87677c",
  null
  
)

export default component.exports